import { useParams, useRouteMatch } from 'react-router-dom';
import { ROUTES } from 'utils/constants/routes';

/**
 * Hook which returns an object containing all url params and their values
 * (working with nested routes unlike base useParams)
 * @returns {*}
 */
export default function useRealParams() {
  const matchTest = useRouteMatch(ROUTES.TEST.BASE);
  const params = useParams();
  if (matchTest) {
    return matchTest.params ?? {};
  }
  return params ?? {};
}